import React from 'react'
import ASelect from 'react-select/async'
import debounce from 'lodash-es/debounce'
import getStyles from './Select/styles.js'
import Label from './Input/Label'
import { loadOptions, getValue } from './Reference'
import { Output as MultiPicklist } from './MultiPicklist'
import get from 'lodash-es/get'
import LinkWrapper from '../LinkWrapper/LinkWrapper'

export class Input extends React.Component {
  state = {
    options: [],
    selectedValues: null
  }

  onChange = (v) => {
    let { onChange, onValueChange } = this.props
    onChange?.(v)
    this.setState({ selectedValues: v })
    onValueChange?.(Array.isArray(v) ? v.map(x => x.value) : [])
  }
  onKeyDown = (e) => {
    const ref = this.select?.select?.select
    if (e.keyCode === 13 && ref?.menuListRef) {
      if (ref?.props?.options?.length === 0) return;
      e.stopPropagation()
    }
  }

  getRef = ref => this.select = ref

  dLoadOptions = debounce((searchText, callback) => {
    loadOptions(this, searchText).then(callback)
  }, 300)
  render () {
    let value = this.state.selectedValues || getValue(this.props, this.state.selectedValues) || []

    return (
      <div className={`w-100 input-wrapper`}>
        <Label {...this.props} />
        <ASelect
          ref={this.getRef}
          onKeyDown={this.onKeyDown}
          isMulti
          value={!this.props.uncontrolled ? value : undefined}
          defaultValue={this.props.uncontrolled ? value : undefined}
          className={`input ${(this.props.required && !value && `is-invalid`) || ''}`}
          cacheOptions
          loadOptions={this.dLoadOptions}
          onChange={this.onChange}
          isClearable
          menuPortalTarget={document.body}
          components={{
            ...!this.props.icon && { DropdownIndicator: () => null },
            IndicatorSeparator: () => null
          }}
          placeholder={this.props.placeholder || ''}
          styles={getStyles(this.props)}
          classNamePrefix={`react-multi-select`}
          menuPlacement={`auto`}
          closeMenuOnSelect={false}
          defaultMenuIsOpen={this.props.autoFocus || false}
        />
        <style jsx>{`
          .react-multi-select__multi-value__remove {
            cursor: pointer;
          }
          `}</style>
      </div>
    )
  }
}

export class Output extends React.Component {
  render () {
    let defaultValue = getValue(this.props)
    let data = defaultValue && defaultValue.map(v => v.label)

    return <MultiPicklist data={data} />
  }
}

export const DisplayAs = props => {
  let { displayAs, record, fieldPath } = props
  let data = get(record, fieldPath)

  data = Array.prototype.concat(data).filter(x => x)

  let cmps = []
  for (let item of data) {
    let dsId = item && item.$ && item.$.dataSourceId
    let display = Array.prototype.concat(displayAs).filter(x => x)
    if (!dsId) display = display[0]
    else display = display.find(d => d.dataSourceId === dsId)
    if (display) {
      let { displayType, linkType, value, label, prefix = '', target } = display
      if (displayType === 'link') {
        const lab = get(item, label && label.replace(fieldPath + '.', ''))
        if (linkType === 'none') cmps.push(lab)
        else {
          const val = get(item, value && value.replace(fieldPath + '.', ''))
          cmps.push(<LinkWrapper style={{ color: 'white' }} type={linkType} link={prefix + (val != null ? val : '')} target={target}>{lab}</LinkWrapper>)
        }
      }
    }
  }
  return <MultiPicklist data={cmps} />
}
